import React from 'react';
import { SvgIconProps } from '../types';

export default function Accessibility2({
  fill,
  width,
  height,
  className,
  ariaLabel,
  ariaHidden,
}: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 37 37"
      fill="none"
      width={width}
      height={height}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <path
        d="M21.1228 29.3658C21.357 29.881 21.8252 30.162 22.3404 30.162C22.5276 30.162 22.7152 30.1153 22.9024 30.0215C23.6047 29.6935 23.8861 28.8974 23.558 28.1949C23.558 28.1949 20.982 22.2937 20.5139 20.1392C20.3267 19.3898 20.2329 17.376 20.1859 16.4394C20.1859 16.1114 20.3731 15.8304 20.6544 15.737L26.4151 14.0042C27.1175 13.817 27.5392 13.0204 27.3517 12.3181C27.1645 11.6157 26.368 11.1939 25.6656 11.3815C25.6656 11.3815 20.3264 13.1143 18.406 13.1143C16.5328 13.1143 11.2402 11.4282 11.2402 11.4282C10.5378 11.241 9.7413 11.5687 9.50737 12.2711C9.27313 13.0205 9.69457 13.8166 10.444 14.0039L16.2047 15.7367C16.4856 15.8305 16.7199 16.1115 16.6732 16.4391C16.6264 17.3758 16.5327 19.3898 16.3452 20.139C15.8767 22.2936 13.301 28.1947 13.301 28.1947C12.973 28.8971 13.301 29.6936 13.9567 30.0212C14.1439 30.115 14.3314 30.1617 14.5186 30.1617C15.0338 30.1617 15.549 29.8808 15.7363 29.3656L18.5001 23.7454L21.1228 29.3658Z"
        fill={fill}
      />
      <path
        d="M21.1228 9.13292C21.1228 10.5815 19.9486 11.7556 18.5001 11.7556C17.0515 11.7556 15.8774 10.5815 15.8774 9.13292C15.8774 7.68436 17.0515 6.51021 18.5001 6.51021C19.9486 6.51021 21.1228 7.68436 21.1228 9.13292Z"
        fill={fill}
      />
      <path
        d="M37 18.5C37 8.28987 28.71 0 18.5 0C8.28996 0 0 8.28996 0 18.5C0 28.71 8.28996 37 18.5 37C28.71 37 37 28.71 37 18.5ZM3.09114 18.5C3.09114 9.97595 10.0227 3.09114 18.5 3.09114C26.9773 3.09114 33.9089 9.97561 33.9089 18.5C33.9089 27.0244 27.0244 33.9089 18.5 33.9089C9.97561 33.9089 3.09114 27.0244 3.09114 18.5Z"
        fill={fill}
      />
    </svg>
  );
}

<svg
  width="37"
  height="37"
  viewBox="0 0 37 37"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
></svg>;
